// extracted by mini-css-extract-plugin
export default {"-large":"brand-fonts-module__-large--A1SpG","brandFonts":"brand-fonts-module__brandFonts--nlKlc","brandFontItem":"brand-fonts-module__brandFontItem--W9jDJ"};